import { Box, Grid2 as Grid, SxProps, Theme } from "@mui/material";
import { FormGroup, FormGroupProps } from "@cofano/cck";
import { Language } from "utils";

export type ContainerAmountSummaryProps = {
	loadingAmount: number | null;
	dischargingAmount: number | null;
	loadingTeu: number | null;
	dischargingTeu: number | null;
	amountDifference?: number | null;
	teuDifference?: number | null;
	borderless?: boolean;
}

const ContainerAmountSummary = ({ borderless, ...summary }: ContainerAmountSummaryProps) => {
	const borderStyle: SxProps<Theme> = borderless ? {} : {
		borderTop: 1,
		borderBottom: 1,
		borderColor: "divider",
	};

	const showDifferenceColumn = typeof summary.amountDifference === "number" && typeof summary.teuDifference === "number";

	const columnSize: Parameters<typeof Grid>[0]["size"] = {
		xs: 12,
		md: showDifferenceColumn ? 4 : 6,
	};

	const formGroupProps: Omit<FormGroupProps, "label"> = {
		labelPlacement: "left-center",
		labelWidth: 150,
	};

	return (
		<Box className="container-amount-summary" sx={{ ...borderStyle, padding: 1 }}>
			<Grid spacing={3} container>
				<Grid size={columnSize}>
					<FormGroup {...formGroupProps} label={<b>{Language("LOADING")}</b>} />
					<FormGroup {...formGroupProps} label={Language("AMOUNT")}>{summary.loadingAmount}</FormGroup>
					<FormGroup {...formGroupProps} label={Language("TEU")}>{summary.loadingTeu}</FormGroup>
				</Grid>
				<Grid size={columnSize}>
					<FormGroup {...formGroupProps} label={<b>{Language("DISCHARGING")}</b>} />
					<FormGroup {...formGroupProps} label={Language("AMOUNT")}>{summary.dischargingAmount}</FormGroup>
					<FormGroup {...formGroupProps} label={Language("TEU")}>{summary.dischargingTeu}</FormGroup>
				</Grid>
				{showDifferenceColumn && (
					<Grid size={columnSize}>
						<FormGroup {...formGroupProps} label={<b>{Language("DIFFERENCE")}</b>} />
						<FormGroup {...formGroupProps} label={Language("AMOUNT")}>
							{typeof summary.amountDifference === "number" && (((summary.amountDifference) > 0 ? "+" : "") + summary.amountDifference)}
						</FormGroup>
						<FormGroup {...formGroupProps} label={Language("TEU")}>
							{typeof summary.teuDifference === "number" && (((summary.teuDifference) > 0 ? "+" : "") + summary.teuDifference)}
						</FormGroup>
					</Grid>
				)}
			</Grid>
		</Box>
	);
};

export default ContainerAmountSummary;
